













import { Component, Vue, Prop } from 'vue-property-decorator';

import { Plan } from '@/domains/work';
import { Row } from '@/domains/table';
import { CourseGroup } from '@/domains/course';

@Component({
  name: 'PriorityTeacherCourseGroupCampusReportTable',
  components: {
  },
})
export default class PriorityTeacherCourseGroupCampusReportTable extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  /** headers */
  private headers: string[] = ['广州校区南校园', '广州校区北校园', '珠海校区', '广州校区东校园', '深圳校区', '其他', '总计'];

  /** subHeaders */
  private subHeaders: string[] = ['执行中', '已结束'];

  /** 数据列表 */
  private datas: Array<Row<CourseGroup, number[]>> = [];

  private mounted() {
    this.bus.$on('priority-teacher-course-group-campus-report-table', (datas: Array<Row<CourseGroup, number[]>>) => { this.datas = datas; });
  }
}
